/**
 * 初始化事件
 * opts: {
 *    name: globalEvent,
 *    type: 'MIX_VM' || 'VUE' || 'IN_SPA' || 'ALL'
 * }
 */

const EVENT_BUS_TYPE = {
  IN_VM: 'IN_VM', // 调用VM数据
  IN_VUE: 'IN_VUE', // 调用VUE数据
  IN_SPA: 'IN_SPA', // 调用SPA数据
  ALL: 'ALL', // 调用ALL数据
  CUSTOM: 'CUSTOM'
}

let eventConfigList = []

const install = function(Vue, opts) {
  var bus = new Vue()

  if (!opts.type) {
    opts.type = EVENT_BUS_TYPE.ALL
  }

  if (opts.type === EVENT_BUS_TYPE.ALL || opts.type === EVENT_BUS_TYPE.IN_VM) {
    /**
     * 注册vm.$bus全局变量
     */
    Object.defineProperty(Vue.prototype, `$${opts.name}` || '$bus', {
      // for "this.$bus"
      get: function() {
        return bus
      },
      set: function(evt) {
        // alt way to send an event (this.$bus=['event_name',arg1,arg2])
        if (typeof evt === 'string') evt = [evt]
        bus.$emit.apply(bus, evt)
      }
    })
  }

  if (opts.type === 'ALL' || opts.type === 'IN_VUE') {
    /**
     * 注册 Vue._bus 属性
     */
    Vue[`_${opts.name}` || '_bus'] = bus
  }

  if (opts.type === 'ALL' || opts.type === 'IN_SPA') {
    /**
     * 注册 Vue._bus 属性
     */
    Vue.mixin({
      created: function() {
        // add option "$bus" instead bus.$on in created hook
        var $bus = this.$options[`$${opts.name}`]
        this.$busListeners = {}
        for (var name in $bus) {
          this.$busListeners[name] = $bus[name].bind(this) // rebind and remember each declared listener
          bus.$on(name, this.$busListeners[name]) // register a listener for the event
        }
      },
      beforeDestroy: function() {
        // unreg listeners
        for (var name in this.$busListeners) bus.$off(name, this.$busListeners[name])
        this.$busListeners = null
      }
    })
  }

  // 定制逻辑
  if (opts.type === 'CUSTOM') {
    var $customBus = {
      $on: (key, listener) => {
        eventConfigList.push({
          key: key,
          listener: listener
        })
        bus.$on(key, listener)
      },

      $once: (key, listener) => {
        bus.$on(key, listener)
      },

      $off: (key, listener) => {
        eventConfigList = eventConfigList.filter((eventConfig) => {
          return (
            (eventConfig.key !== key && !listener) ||
            (eventConfig.key !== key && eventConfig.listener === listener)
          )
        })
        bus.$off(key, listener)
      },

      $emit(key, obj, config) {
        if (!config) {
          bus.$emit(key, obj)
        } else if (config.opt === 'STARTS_WITH') {
          const emitList = eventConfigList.filter((eventConfig) => {
            return eventConfig.key.startsWith(key)
          })
          emitList.forEach((emitConfig) => {
            bus.$emit(emitConfig.key, obj)
          })
        } else if (config.opt === 'INCLUDES') {
          const emitList = eventConfigList.filter((eventConfig) => {
            return eventConfig.key.includes(key)
          })
          emitList.forEach((emitConfig) => {
            bus.$emit(emitConfig.key, obj)
          })
        } else if (config.opt === 'ENDS_WITH') {
          const emitList = eventConfigList.filter((eventConfig) => {
            return eventConfig.key.endsWith(key)
          })
          emitList.forEach((emitConfig) => {
            bus.$emit(emitConfig.key, obj)
          })
        }
      }
    }

    Object.defineProperty(Vue.prototype, `$${opts.name}` || '$bus', {
      // for "this.$bus"
      get: function() {
        return $customBus
      },
      set: function(evt) {
        // alt way to send an event (this.$bus=['event_name',arg1,arg2])
        if (typeof evt === 'string') evt = [evt]
        bus.$emit.apply($customBus, evt)
      }
    })
  }
}

const EventbusPlugin = {
  install: install,
  EVENT_BUS_TYPE: EVENT_BUS_TYPE
}

export default EventbusPlugin
